import { makeStyles } from '@mui/styles'
import Colors from 'utils/Colors'

const styles = makeStyles(() => ({
  root: {
    width: '100%',
    height: '100% ',
    display: 'flex',
    justifyContent: 'flex-start',
    flexDirection: 'column',
    gap: '1rem',
    '& p > span': {
      fontWeight: 600,
    },

    '& li span': {
      textTransform: 'capitalize',
    },

    '& p > a': {
      color: Colors.loginLigthenPrimaryColor,
      textDecoration: 'none',
      '&:hover': {
        textDecoration: 'underline',
      },
    },
  },

  answersWrapper: {
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'space-between',
    flexDirection: 'row',
    minWidth: '100%',
    flexWrap: 'wrap',
    gap: '1.5rem',
    '@media (max-width: 1180px)': {
      flexDirection: 'column',
      gap: 0,
    },
    '@media (max-width: 400px)': {
      alignItems: 'center',
    },
  },

  answerColumn: {
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'flex-start',
    flexDirection: 'column',
    gap: '1rem',
    width: 'calc(50% - 1rem)',
    '& > div': {
      width: '100%',
    },
    '@media (max-width: 1180px)': {
      width: '100%',
    },
    '@media (max-width: 400px)': {
      width: 'calc(100% - 3rem)',
    },
  },

  answerColumnUnique: {
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'flex-start',
    flexDirection: 'column',
    gap: '0.5rem',
    width: '100%',
    '& > div': {
      width: '100%',
    },
  },

  title: {
    width: '100%',
    color: Colors.white,
    backgroundColor: Colors.primaryColor,
    fontWeight: '600',
    textAlign: 'center',
    fontSize: '1.6rem',
    padding: '0.5rem',
    borderRadius: 5,
    margin: 0,
  },

  answerDisplay: {
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'flex-start',
    flexDirection: 'column',
    padding: '1rem',
    gap: '1rem',
    width: '100%',
    height: '100%',
  },

  answersContainer: {
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'space-between',
    flexDirection: 'column',
    width: '100%',
    padding: '1rem',
    border: `1px solid ${Colors.gray}`,
    borderRadius: '3px',
    gap: '1rem',
    backgroundColor: '#F1F1F1',
  },

  condensedAnswer: {
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'space-between',
    flexDirection: 'column',
    width: '100%',
    padding: '1rem',
    border: `1px solid ${Colors.gray}`,
    borderRadius: '3px',
    gap: '1rem',
    backgroundColor: Colors.lightGray,
  },

  justified: {
    textAlign: 'justify',
  },
}))

export default styles
